import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';

// Настройка версии документов для запросов к API
const DOC_VERSION = process.env.REACT_APP_DOC_VERSION;

axios.interceptors.request.use((config) => {
  // Автоматическая передача токена сессии для всех авторизованных запросов
  const sessionToken = localStorage.getItem('sessionToken');
  if (sessionToken) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${sessionToken}`;
    config.headers['x-session-token'] = sessionToken;
  }

  if (config.url && config.url.includes('/api/v1')) {
    config.headers = config.headers || {};
    config.headers['x-app-version'] = DOC_VERSION;

    if (!config.params) {
      config.params = {};
    }
    config.params.version = DOC_VERSION;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Если сессия истекла или была отозвана на сервере (401), возвращаем пользователя на страницу логина
    if (error.response && error.response.status === 401) {
      const isAuthCheck = error.config?.url?.includes('/api/v2/auth/login') ||
                          error.config?.url?.includes('/api/v2/auth/validate-session');
      if (!isAuthCheck && window.location.pathname !== '/') {
        console.warn('[Axios] Сессия истекла или недействительна. Перенаправление на страницу входа.');
        localStorage.removeItem('sessionToken');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
